import { Box, Typography, Button, Paper, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * El link de una invitación por correo (?inv=) se abrió con la sesión de OTRO
 * correo, por ejemplo en un equipo compartido (2026-10-09). Se ofrece entrar
 * con el correo de la invitación (cierra la sesión abierta) o seguir con la
 * cuenta abierta (quien cambió de correo).
 *
 * Props:
 * - position: la vacante (para el título)
 * - invitedEmail: correo de la invitación, oculto (j***@gmail.com)
 * - sessionEmail: correo de la sesión abierta (el de este navegador)
 * - onUseInvitation, onContinue
 * - loading: mientras se cierra la sesión
 */
const PortalInvitationMismatch = ({ position, invitedEmail, sessionEmail, onUseInvitation, onContinue, loading = false }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', px: 2, pt: { xs: '6vh', md: '10vh' }, pb: 6 }}>
      <Box sx={{ width: '100%', maxWidth: 480 }}>
        {position?.name && (
          <Typography variant="h5" fontWeight={700} sx={{ textAlign: 'center', mb: 3 }}>
            {position.name}
          </Typography>
        )}
        <Paper elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2, p: 4 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
            {t('portal.invitation.title', { email: invitedEmail })}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {t('portal.invitation.sessionOpen', { email: sessionEmail })}
          </Typography>
          <Button
            variant="contained"
            fullWidth
            disabled={loading}
            onClick={onUseInvitation}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
            sx={{ backgroundColor: '#6A5AF9', '&:hover': { backgroundColor: '#5B4DE8' }, py: 1.5, mb: 1.5 }}
          >
            {t('portal.invitation.useInvitation')}
          </Button>
          <Button
            variant="text"
            fullWidth
            disabled={loading}
            onClick={onContinue}
            sx={{ color: '#6A5AF9', textTransform: 'none' }}
          >
            {t('portal.invitation.continueAs', { email: sessionEmail })}
          </Button>
        </Paper>
      </Box>
    </Box>
  );
};

export default PortalInvitationMismatch;
